<template>
  <div>
    <auth-card authType="signIn">
      <template v-slot:left>
        <div v-show="!verify_user">
          <h1 class="font-weight-bold pt-3 pl-xl-5 f-32">Get Started With QR API</h1>
          <button type="button" disabled class=" d-none d-sm-block white-round-cap white-round-cap-desktop bg-white border-0 rounded-circle pl-sm-4 pr-sm-4 pt-sm-3 pb-sm-3">
            <span class="font-weight-bold">or</span>
          </button>
          <button type="button" disabled class="d-block d-sm-none white-round-cap white-round-cap-mobile bg-white border-0 rounded-circle pl-sm-4 pr-sm-4 pt-sm-3 pb-sm-3">
            <span class="font-weight-bold">or</span>
          </button>
          <div class="pt-sm-5 text-center pt-2 pb-5 d-flex justify-content-center" id="signInDiv" ></div>
        </div>
        <div class="text-left pl-3 pl-sm-2" v-show="verify_user">
          <h1 class="font-weight-bold pt-3 pl-xl-2 pl-0 f-32">Get Started With QR API</h1> 
          <p id="free-requests" class=" pl-xl-2 pl-0 f-14 d-none d-sm-block">
            Sign up for a 14-day free trial <br /> account and get first 20 API <br/> requests free.
          </p>
          <p id="free-requests" class=" pt-3 pl-xl-2 pl-0 f-14 d-block d-sm-none">
            Sign up for a 14-day free trial account and get first 20 API requests free.
          </p>
          <p  class=" pl-xl-2 pl-0 f-14">
            No credit card required.
          </p>
          <p  class=" pl-xl-2 pl-0 f-14">
            Please note a paid subscription is required to process API requests after free trial.
          </p>
        </div>
      </template>
      <template v-slot:right>
        <div class="pt-sm-4 px-sm-5 pb-sm-5" v-if="!verify_user">
          <h2 class="text-center f-20">Login With Email</h2>
          <form @submit.prevent="onSubmit" class="pt-sm-3 text-center pt-2">
            <div class="input">
              <v-input
                input-place-holder="Email Address"
                id="loginEmail"
                label-name=""
                input-type="email"
                @inputData="inputLoginValue"
                :input-value="email"
                type="email"
                popover-title="Email Address"
                popover-content="We will use your valid email address as a unique
username/identifier as well as point-of-contact for transaction details and customer support"
                popover-placement="left"
                popover-icon="lock"
                :popover-ref="rndStr(8)"
                :error-status="error.borderEmail || false">
              </v-input>
            </div>
            <div class="input">
              <v-input
                input-place-holder="Password"
                id="loginPassword"
                label-name=""
                :input-type="passwordFieldType"
                @inputData="inputLoginValue"
                type="password"
                popover-title="Password"
                popover-content="Make sure the password you have entered is strong
(It should contain minimum of 8 characters)"
                popover-placement="left"
                popover-icon="info"
                :popover-ref="rndStr(8)"
                :error-status="error.borderPassword || false">
              </v-input>
            </div>
            <p class="pt-sm-1 text-sm-left pl-sm-2 error-text">
              <span>{{error.message}}</span>
              <span v-if="error.link">
                <router-link :to="{name: error.link}" tag="a" class="link-text">
                   {{error.linkText}}
                </router-link>
              </span>
            </p>
            <div class="pr-sm-4 pr-4 pt-2 pl-sm-2 pl-2 pt-sm-2">
              <div class="text-sm-left text-left">
                <router-link :to="{ name: 'reset-password'}" class="text-color pt-sm-2">
                  Forgot Password?
                </router-link>
              </div>
            </div>
            <div class="submit text-center mt-5 mb-3 mt-sm-5">
              <button type="submit" class="rounded border-0 w-75" :disabled="$v.$invalid">LOGIN</button>
            </div>
            <div>
              New user?
              <router-link :to="{ name: 'sign-up' }" class="link-text">
                SIGN UP
              </router-link>
            </div>
          </form>
<!--          <div class="text-muted d-block d-sm-none text-center my-5">-->
<!--            By signing up you agree to our Terms of Use, Privacy Policy, and Data Protection Addendum-->
<!--          </div>-->
        </div>
        <div class="pt-sm-4 px-sm-5 pb-sm-5 otp-verification-min-height" v-if="verify_user">
          <div class="px-5 btn-back">
            <span class="cursor primary-color f-14" @click="hideOTPVerification"> <img src="../../assets/svg/back_arrow.svg" alt="Back Arrow" class="mr-2"> BACK</span>
          </div>
          <h2 class="text-center f-16 fw-400 text-color">Verify your account</h2>
          <p class="text-center f-12 text-color">Please enter the 6 digit code sent to your Email</p>
          <div class="d-flex justify-content-center mt-3">
            <template v-for="(item,key) in verification_code">
                <input type="number" :id="key" class="verification-box mr-2"  @keydown="singleDigit" :class="{'error-border': is_verification_code_invalid}" >
            </template>
          </div>
          <div v-if="is_verification_code_invalid" class="f-12 error-text mt-2 text-end mr-11">
              <span>Incorrect OTP</span>
          </div>
          <div class="float-right f-12 mt-2 mr-8">  
            <span class="timer-color"> 
              <button 
                :disabled="timer !==0" 
                @click="onResendVerificationCode" 
                class="btn-default"
                :class="{'btn-default-active' : timer === 0 }"
                >Resend</button> 
              <span class="timer-margin-right" v-if="timer !==0">({{timer}}s)</span>
            </span>
          </div>
          <div class="submit text-center mt-verify">
            <button 
              type="submit" 
              class="rounded border-0 w-75 fw-500" 
              :disabled="verification_code_disabled"
              @click="onOTPVerification" 
              >
              VERIFY ACCOUNT
            </button>
          </div>
          <div class="mt-5 text-center f-12">
              <span><span class="text-color">Having issues?&nbsp;</span> <a :href="supportUrl" target="_blank" class="link-text">Contact Support</a> </span>
          </div>
        </div>
      </template>
    </auth-card>
    <vue-recaptcha
      ref="invisibleRecaptcha"
      @verify="onVerify"
      @expired="onExpired"
      size="invisible"
      :sitekey="siteKey">
    </vue-recaptcha>
  </div>
</template>

<script>
  import { required, email, minLength } from 'vuelidate/lib/validators'
  import VueRecaptcha from 'vue-recaptcha'; 
  import Cookies from 'js-cookie';

  export default {
      data() {
          return {
              email: '',
              password: '',
              error: {
                  message: '',
                  type: '',
                  borderEmail: false,
                  borderPassword: false,
                  link: '',
                  linkText: ''
              },
              redirectMessage: this.$route.params.redirectMessage,
              passwordFieldType: 'password',
              siteKey: process.env.VUE_APP_SITEKEY,
              verify_user : false,
              is_verification_code_invalid : false,
              verification_code_disabled : true,
              timer : 30,
              verification_code : {
                first_value : null,
                second_value : null,
                third_value :null,
                fourth_value : null,
                fifth_value : null,
                sixth_value :null
              },
              resend_timer : null,
              supportUrl : `${process.env.VUE_APP_Website}/support.html#chatWithUs`,
              request_type : 'login_user'
          }
      },
      methods: {
        inputLoginValue(id, value, isValid) {
          id === 'loginEmail' ? this.email = value : this.password = value;
        },
          onVerify(ReCaptchaToken) {
              if(this.request_type === 'login_user'){
                this.loginUser(ReCaptchaToken);
              }else if(this.request_type === 'resend_otp'){
                this.resendVerificationCode(ReCaptchaToken);
              }else if(this.request_type === 'verify_otp'){
                this.checkVerificationCode(ReCaptchaToken);
              }
          },
          loginUser(token){
            const formData = {
                  email: this.email,
                  password: this.password,
                  token: token,
              };
              this.$store.dispatch('login', formData)
                  .then(res => {
                      if(res.data.status === 'success') {
                          this.$store.dispatch('setToken',{
                              token: res.data.idToken,
                              userId: res.data.id,
                              expiry: res.data.expiresIn,
                              plan_type : res.data.plan_type
                          });
                          this.$router.push({
                              name: 'dashboard-api'
                          });
                      }
                  })
                  .catch(error => {
                      if (!error.response) {
                          this.error = {
                              message: 'Connection error. Refresh page and try again',
                              type: 'general'
                          };
                      } else {
                           this.error = {
                              message: error.response.data.message,
                              type: error.response.data.type,
                              borderPassword: error.response.data.type === 'password',
                              borderEmail: error.response.data.type === 'email' ||
                                            error.response.data.type === 'email-NV',
                             link: error.response.data.link,
                             linkText: error.response.data.linkText,
                          };
                          if(error.response.data.type === 'email-NV'){
                            this.verify_user = true;
                          }
                      }
                  })
          },
          onSubmit(){
            this.request_type = 'login_user';
            this.$refs.invisibleRecaptcha.execute();
          },
          onExpired: function () {
            this.$refs.invisibleRecaptcha.reset();
          },
          resetOTPValues(){
            this.verification_code = {
              first_value : null,
              second_value : null,
              third_value :null,
              fourth_value : null,
              fifth_value : null,
              sixth_value :null
            }
          },
          hideOTPVerification(){
            this.verify_user = false;
            this.is_verification_code_invalid = false;
            this.resetOTPValues();
          },
          updateFocusOfInput(id,direction){
            if(id !== 'sixth_value' && direction === 'forward'){
              const input_list_order = Object.keys(this.verification_code);
              const next_position_id = input_list_order.indexOf(id) + 1;
              const next_element = document.getElementById(input_list_order[next_position_id]);
              next_element.focus();
            }else if(id !== 'first_value' && direction === 'backward'){
              const input_list_order = Object.keys(this.verification_code);
              const prev_position_id = input_list_order.indexOf(id) - 1;
              const prev_element = document.getElementById(input_list_order[prev_position_id]);
              prev_element.focus();
            }
          },
          singleDigit(e){
            let id = e.target.id;
            const direction = e.keyCode !== 8 ? 'forward' : 'backward';
            if(e.keyCode >=48 && e.keyCode <=57){
              setTimeout(() => {
                this.verification_code[id] = e.key;            
                this.validateVerificationCodeStatus();
                document.getElementById(id).value = e.key;
                this.updateFocusOfInput(id,direction);
              }, 0);
            }else if(e.keyCode === 8){
              setTimeout(() => {
                this.verification_code[id] = null;
                this.validateVerificationCodeStatus();
                document.getElementById(id).value = null;
                this.updateFocusOfInput(id,direction);
              }, 0);
            }
          },
          validateVerificationCodeStatus(){
            let status = false;
            for(let item of Object.values(this.verification_code)){
                if(item == null || item ===''){
                  status = true;
                }
            }
            this.verification_code_disabled = status;
          },
          onResendVerificationCode(){
            this.request_type = 'resend_otp';
            this.$refs.invisibleRecaptcha.execute();
          },
          resendVerificationCode(token){
            this.runTimer();
            const payload = {
              "email" : this.email,
              "token" : token
            }
            this.$store.dispatch('resendVerificationCode',payload)
            .then((res)=>{
              this.$root.$children[0].$refs.alertBox.show({
                type: 'success',
                message: `Verification code sent successfully.`
              });
            })
            .catch(e=>{
              this.$root.$children[0].$refs.alertBox.show({
                type: 'error',
                message: e.response.data.message
              });
            });
          },
          onOTPVerification(){
            
            this.$gtag.event('Clicked Verify Account button',{
              'Event_Definition'   : 'User click on verify account button',
              'Event_Nomenclature' : 'qrapi-web-verify-account' 
            });

            this.request_type = 'verify_otp';
            this.$refs.invisibleRecaptcha.execute();
          },
          checkVerificationCode(token){

            this.verification_code_disabled = true;
            let verification_code = Object.values(this.verification_code).join('');
              
            let payload = {
              "email" : this.email,
              "verification_code" : verification_code,
              "token" : token
            };

            this.$store.dispatch('checkVerificationCode',payload)
            .then(res=>{
              
              this.$store.dispatch('setToken',{
                token: res.data.idToken,
                userId: res.data.id,
                expiry: res.data.expiresIn
              });

              let redirect_to = 'dashboard-api';
              let query = {};

              if(Cookies.get('cycle')){
                redirect_to = 'dashboard-subscription';
                query['tab'] = 'plans';
                query['duration'] = Cookies.get('cycle');
                query['plan']     = Cookies.get('plan_name'); 
                Cookies.remove('duration');
                Cookies.remove('plan_name');
              }

              this.$router.push({
                name: redirect_to,
                query: query
              });

              setTimeout(()=>{
                this.$root.$children[0].$refs.userinfoModel.show();
              },200);

            }).catch( ()=>{
              this.is_verification_code_invalid = true;
            }).finally(()=>{
              this.verification_code_disabled = false;
            })
          },
          runTimer(){
            this.timer = 30;
            this.resend_timer = setInterval(()=>{
              this.timer--;
              if(this.timer === 0){
                clearInterval(this.resend_timer);
              }
            },1000);
          }
      },
      validations: {
          email : {
              required,
              email
          },
          password: {
              required,
              minLen: minLength(8),
              containsSpecial: function(value) {
                return /[#?!@$%^&*-]/.test(value)
              }
          }
      },
      components: {
          'auth-card': () => import(/*webpackChunkName: "authCard"*/ '../widgets/authCard'),
          'v-input': () => import(/*webpackChunkName: "inputBox"*/ '../widgets/input-box'),
          VueRecaptcha
      },
      watch: {
          email(){
              // binding this to the data value in the email input
              this.error = {};
              this.redirectMessage = '';
          },
          password(){
              // binding this to the data value in the password input
              this.error = {};
              this.redirectMessage = '';
          },
          verify_user(newValue,oldValue){
            if(newValue === true){
              this.runTimer();
            }else if(newValue === false){
              clearInterval(this.resend_timer);
            }
          }
      },
      created () {
          this.$store.dispatch('tryAutoLogin')
      },
      mounted () {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
        document.head.appendChild(recaptchaScript);
      }
  }
</script>

<style lang="scss" scoped>
@import "../scss/_variable.scss";

.text-color {
  color : $text-color !important;
}
.error-text {
  color: $invalid-text !important;
}

.f-12 {
  font-size: 12px !important;
}
.f-14{
  font-size: 14px !important;
}

.f-16 {
  font-size: 16px !important;
}

.f-20 {
  font-size: 20px;
}
.f-32 {
  font-size: 32px;
}

.fw-400 {
  font-weight: 400 !important;
}

.fw-500 {
  font-weight: 500 !important;
}
.otp-verification-min-height {
  min-height: 436px;
}

.btn-back {
  padding-left: 1rem !important;
  padding-bottom: 1.5rem;
}
.cursor {
  cursor: pointer;
}

.primary-color {
  color : $theme-color
}

.verification-box {
  width: 40px !important;
  height: 40px !important;
  text-align: center;
  border : 2px solid $popover-icon;
  border-radius: 6px;
  outline : none !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.error-border {
  border: 2px solid $invalid-text !important;
}
.mt-verify {
  margin-top: 79px !important;
}

.btn-default {
  background: $background-color;
  border: none;
  color : $default;
}

.btn-default-active {
  color : $theme-color;
  outline: none;
  margin-right: 5px !important;
}

.timer-color {
  color : $default;
}

.timer-margin-right{
  margin-right: 12px !important;
}

.mr-8 {
  margin-right:8% !important
}

.mr-11{
  margin-right: 11% !important;
}

.text-end {
  text-align: end ;
}
</style>
